import { useIsOverflowing } from "shared/hooks";

import Tooltip from "features/components/Tooltip";

const OverflowingColumnCell = ({ value }: { value: string }) => {
  const { ref: textRef, isOverflowing } = useIsOverflowing();

  const content = (
    <div ref={textRef} className="truncate text-ellipsis hover:underline">
      {value}
    </div>
  );

  if (isOverflowing) {
    return (
      <Tooltip title={value} enterDelay={750} placement="bottom-start">
        <div className="w-full flex flex-row items-center">{content}</div>
      </Tooltip>
    );
  } else {
    return content;
  }
};

export default OverflowingColumnCell;
